import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const DONOR_SOURCE_NOTE = "Donor information is compiled from publicly available documents (annual CSR reports) and is provided for reference only.";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const TIER_STYLES = {
  reviewed:  "bg-emerald-100 text-emerald-800 border-emerald-300",
  confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  high:      "bg-[#f6dde0] text-[#8a1420] border-[#e3b4ba]",
  review:    "bg-amber-50 text-amber-700 border-amber-300",
  candidate: "bg-amber-50/70 text-amber-600 border-amber-200",
  rejected:  "bg-rose-50 text-rose-700 border-rose-200",
};

export const REGISTRY_STYLES = {
  incometax: { bg: "bg-sky-50 text-sky-700 border-sky-200", name: "Income Tax 12A/80G", short: "PAN" },
  darpan:    { bg: "bg-purple-50 text-purple-700 border-purple-200", name: "NGO Darpan", short: "Darpan" },
  fcra:      { bg: "bg-amber-50 text-amber-700 border-amber-200", name: "FCRA (MHA)", short: "FCRA" },
  csr1:      { bg: "bg-emerald-50 text-emerald-700 border-emerald-200", name: "MCA CSR-1", short: "CSR-1" },
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function monthFromName(n) {
  const i = MONTHS.findIndex((m) => n.slice(0, 3).toLowerCase() === m.toLowerCase());
  return i >= 0 ? i + 1 : 0;
}

// Normalise any date we store (ISO, "31-May-2021", "31-December-2025", "DD/MM/YYYY",
// ISO datetime) into a single portal format: "DD MMM YYYY". Non-dates pass through.
export function formatDate(v) {
  if (v === null || v === undefined || v === "") return "—";
  const s = String(v).trim();
  let d, m, y, mt;
  if ((mt = s.match(/^(\d{4})-(\d{2})-(\d{2})/))) { y = +mt[1]; m = +mt[2]; d = +mt[3]; }
  else if ((mt = s.match(/^(\d{1,2})[-/ ]([A-Za-z]+)[-/ ](\d{4})/))) { d = +mt[1]; m = monthFromName(mt[2]); y = +mt[3]; }
  else if ((mt = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})/))) { d = +mt[1]; m = +mt[2]; y = +mt[3]; }
  else return s;
  if (!m || m < 1 || m > 12 || !d || !y) return s;
  return `${String(d).padStart(2, "0")} ${MONTHS[m - 1]} ${y}`;
}

// FCRA / census (2011) state codes used by fcraonline.gov.in
const FCRA_STATES = {
  "01": "Jammu & Kashmir", "02": "Himachal Pradesh", "03": "Punjab", "04": "Chandigarh",
  "05": "Uttarakhand", "06": "Haryana", "07": "Delhi", "08": "Rajasthan",
  "09": "Uttar Pradesh", "10": "Bihar", "11": "Sikkim", "12": "Arunachal Pradesh",
  "13": "Nagaland", "14": "Manipur", "15": "Mizoram", "16": "Tripura",
  "17": "Meghalaya", "18": "Assam", "19": "West Bengal", "20": "Jharkhand",
  "21": "Odisha", "22": "Chhattisgarh", "23": "Madhya Pradesh", "24": "Gujarat",
  "25": "Daman & Diu", "26": "Dadra & Nagar Haveli", "27": "Maharashtra", "28": "Andhra Pradesh",
  "29": "Karnataka", "30": "Goa", "31": "Lakshadweep", "32": "Kerala",
  "33": "Tamil Nadu", "34": "Puducherry", "35": "Andaman & Nicobar Islands",
  "36": "Telangana", "37": "Ladakh",
};

export function fcraStateName(code) {
  if (code === null || code === undefined || code === "") return "—";
  const key = String(code).trim().padStart(2, "0");
  return FCRA_STATES[key] || String(code);
}
